import React from "react";

export default function StreamingPlatforms({
  platforms = [],
  variant = "modern",
  mode = "smartlink"
}) {

  const platformActionMap = {
    spotify: "Pre-Save",
    apple: "Pre-Add",
    deezer: "Pre-Save",
    audiomack: "Pre-Save",
    amazon: "Pre-Save",
    tidal: "Pre-Save",
    youtubemusic: "Pre-order",
    soundcloud: "Pre-Save",
  };

  const activePlatforms = platforms.filter(p => {
    // mode === "smartlink" ? p.enabled && p.url : p.enabled
    if (mode === "smartlink") {
      return p.enabled && p.url;
    }

    if (mode === "bioLink") {
      return p.url; //IMPORTANT FIX
    }

    return p.enabled;

  });

  if (!activePlatforms.length) return null;


  return (
    <div className="space-y-2">
      {activePlatforms.map((stream) => {

        const baseLink = stream.url || "#";
        // console.log(stream,'stream')

        const actionText =
          mode === "presave"
            ? platformActionMap[stream.id?.toLowerCase()] || "Pre-Save"
            : "Play";

        if (variant === "advanced") {
          return (
            <a
              key={stream.id}
              href={baseLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-full rounded-md py-2 px-4 font-semibold text-sm flex items-center justify-center gap-2 shadow-md transition-all
                ${stream.previewBgColor
                  ? `${stream.previewBgColor} text-white`
                  : "bg-white text-black border border-gray-200"
                }`}
            >
              <img
                src={stream.icon}
                alt={stream.name}
                className="w-6 h-6 object-contain"
              />
              <span>{actionText}</span>
            </a>
          );
        }

        if (variant === "base") {
          return (
            <div
              key={stream.id}
              className="flex items-center justify-between"
            >
              <span className="flex items-center gap-2">
                <img
                  src={stream.icon}
                  alt={stream.name}
                  className="h-6 w-6"
                />
                <span className="font-bold text-sm text-gray-800">
                  {stream.name}
                </span>
              </span>

              <a
                href={baseLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white border font-semibold rounded text-xs text-gray-800 hover:text-gray-600 min-w-24 px-3 py-1 text-center"
              >
                {actionText}
              </a>
            </div>
          );
        }

        // modern layout
        return (
          <a
            key={stream.id}
            href={baseLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white flex items-center justify-between rounded-md px-3 py-2"
          >
            <span className="font-semibold text-xs text-gray-800">
              {actionText}
            </span>

            <span className="flex items-center gap-2">
              <span className="font-medium text-xs text-gray-500">
                {stream.name}
              </span>

              <img
                src={stream.icon}
                alt={stream.name}
                className="h-6 w-6"
              />
            </span>
          </a>
        );
      })}
    </div>
  );
}